window.Products.Clothing.WrapSkirt = function() {
};
window.Products.Clothing.WrapSkirt.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.WrapSkirt.id = 77;
window.Products.Clothing.WrapSkirt.slug = 'wrap-skirt';
window.Products.Clothing.WrapSkirt.has_3d = true;
window.Products.Clothing.WrapSkirt.dpi = 150;
window.Products.Clothing.WrapSkirt.use_glb = true;

window.Products.Clothing.WrapSkirt.prototype.setTieColor = function(color, modelViewer){
	var newColor;
	switch(color){
		case '642': // Cream
			newColor = new THREE.Color(0xD9D7B8);
			break;
		case '643': // Black
			newColor = new THREE.Color(0x0A0A08);
			break;
		case '644' : // Dark Grey
			newColor = new THREE.Color(0x2C2B27);
			break;
	}
	modelViewer.object.children[2].material.color = newColor;
};

window.Products.Clothing.WrapSkirt.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 0.03;
	modelViewer.camera.position.y = 0.5;
	modelViewer.camera.position.z =  1.7;
	modelViewer.initalCameraPosition.z = -1.7;
	this.setTieColor('643', modelViewer);

	modelViewer.object.children[1].material.color = new THREE.Color(0.2,0.2,0.19);
	modelViewer.object.children[1].material.emissive = new THREE.Color(0.7,0.7,0.67);
};

window.Products.Clothing.WrapSkirt.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 3.5;
};

window.Products.Clothing.WrapSkirt.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map = modelViewer.texture;
};